import React from 'react'
import Grid from '@mui/material/Grid';
import Sidepic from '../../Images/signIn.png'
function LoginRegister() {
  return (
    <>
     <Grid
          item
          xs={12}
          sm={4}
          md={6}
          
          sx={{
            backgroundImage: Sidepic,
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
      >
      <img src={Sidepic} alt="Demo" width="100%" style={{height:"93.8vh"}} />
      </Grid>  
    </>
  )
}

export default LoginRegister
